import type { ApolloCache } from '@apollo/client';

export const evictRegistryItemPurchaseCountsAfterPurchase = ({ cache, registryItemIds }: { cache: ApolloCache<{}>; registryItemIds: ReadonlyArray<string> }) => {
  const cacheIds = registryItemIds.map(registryItemId => cache.identify({ __typename: 'RegistryItem', id: registryItemId })).filter((id): id is string => Boolean(id));

  if (!cacheIds.length) {
    return;
  }

  cacheIds.forEach(id => {
    cache.evict({ id, fieldName: 'stillNeeded' });
    cache.evict({ id, fieldName: 'alreadyPurchased' });
  });
  cache.gc();
};
